<script setup lang="ts">
import type { Table } from '@wmt/content-blocks'
import type { PlayerRoster, Roster, Team } from '~/types'

interface Props {
  cell: Table.BodyCell<PlayerRoster.Model>
  data: {
    roster: Roster.Model
  }
}

const props = defineProps<Props>()
const team = computed<Maybe<Team.Model>>(() => props.data.roster?.team ?? null)
const { name, logo, slug } = useTeam(team)
</script>

<template>
  <td>
    <div
      v-if="team"
      class="team-name"
    >
      <NuxtLink
        v-if="slug"
        :to="{
          name: 'teams-slug',
          params: {
            slug,
          },
        }"
        class="team-name__link"
      >
        <div class="team-name__logo">
          <UIImage
            v-if="logo"
            :image="logo"
            class="team-name__logo-image"
          />
        </div>
        <span class="team-name__name">
          {{ name }}
        </span>
      </NuxtLink>
    </div>
  </td>
</template>

<style lang="scss" scoped>
.team-name {
  &__link {
    @apply underline inline-flex items-center gap-[10px];
    @apply hover:no-underline;
  }

  &__logo {
    @apply w-[35px] h-[35px] rounded-full border border-primary/20 flex items-center justify-center;

    &-image {
      @apply w-[80%] h-[80%] object-contain;
    }
  }

  &__name {
    @apply text-[18px] font-medium text-primary;
  }
}
</style>
